module.exports = __webpack_public_path__ + "static/media/Shopping-Basket.4bcdbc30.png";